import * as React from 'react';
import {styled} from "@mui/material/styles";
import {Card} from "@mui/material";

export const DetailView = ({children, ...params}) => {

    const Sidebar = styled(Card)(({ theme }) => ({
        '& .MuiCardContent-root': {
            padding: '32px',
        },
        '& .upper-section': {
            '& .title': {
                fontSize: '1.5rem',
                fontWeight: 400,
                marginBottom:'0.5rem',
                color: '#333333',
            },
            '& .MuiAvatar-root': {
                width: '150px',
                height: '150px',
                [theme.breakpoints.down("md")]: {
                    width: '100px',
                    height: '100px',
                },
                [theme.breakpoints.down("sm")]: {
                    width: '90px',
                    height: '90px',
                },
                [theme.breakpoints.down("xs")]: {
                    width: '50px',
                    height: '75px',
                },
            },
        },
        '& .lower-section': {},
        '& .item-details': {
            '& .MuiListItem-root.link': {
                '& .MuiListItemText-secondary':{
                    cursor: 'pointer',
                    color: theme.palette.info.main,
                    '&:hover': {
                        color: theme.palette.primary.main,
                    },
                }
            },
            '& .MuiListItem-root': {
                padding: theme.spacing(1, 0),
                borderBottom: '1px dashed #efefef',
            },
            '& .MuiListItemText-root': {
                '& span': {
                    fontSize: '0.8rem',
                    fontWeight: '400',
                    color: '#666666',
                },
                '& p': {
                    fontSize: '.9rem',
                    fontWeight: '500',
                    color: '#333333',
                }
            },
            '& .MuiListItem-root:last-child': {
                borderBottom: 'none',
            },
        },
        '& .metrics': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            paddingTop: 0,
            paddingBottom: 0,
            '& .MuiListItem-root': {
                padding: '5px 10px',
                width: 'auto',
                minWidth:'60px',
                height:'60px',
                border:'1px dashed #ccc',
                borderRadius:'4px',
                marginRight:'8px',
                '& .MuiListItemText-root': {
                    '& span': {
                        textAlign:'center',
                        fontSize: '0.85rem',
                        fontWeight: 'bold',
                        color: '#666666',
                    },
                    '& p': {
                        textAlign:'center',
                        fontSize: '0.75rem',
                        fontWeight: '400',
                        color: '#666666',
                    }
                },
            },
        },
        '& .profile-details-heading': {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '0.5rem',
            borderBottom: '1px solid #f5f5f5',
            '& h6': {
                fontSize: '1rem',
                fontWeight: '600',
                color: '#333333',
            },
        },
        '& .profile-details': {
            display: 'flex',
            flexDirection: 'column',
            paddingTop: 0,
            paddingBottom: 0,
            '& .MuiListItem-root': {
                width:'auto',
                borderBottom: '1px solid #f5f5f5',
                backgroundColor: `#fefefe`,
                marginBottom: theme.spacing(1),
                padding: theme.spacing(1),
            },
            '& .MuiListItemIcon-root': {
                minWidth: '30px',
                height: '25px',
                marginRight: '5px', // Adjust the margin to reduce spacing
                '& .MuiSvgIcon-root': {
                    backgroundColor: '#f5f5f5',
                    borderRadius: '50%',
                    fontSize: '22px',
                    padding: '0.15rem',
                    textAlign: 'center',
                },
            },
            '& .MuiListItemText-root': {
                '& span': {
                    fontSize: '0.85rem',
                    fontWeight: '400',
                    color: '#666666',
                },
                '& p': {
                    fontSize: '0.9rem',
                    fontWeight: '400',
                    color: '#222222',
                }
            },
        }
    }));

    return (
        <>
            <Sidebar {...params}>
                {children}
            </Sidebar>
        </>
    );
}

